import { Link } from 'react-router-dom';
import { Button } from '../components/ui/button';
import { Music, GlassWater, ConciergeBell, Heart, Check, Tag } from 'lucide-react';

const services = [
  { icon: Music, title: "Animation musicale", desc: "DJ set adapté à tous les publics, blind test intergénérationnel, karaoké pour vos galas et fêtes associatives." },
  { icon: GlassWater, title: "Bar à mocktails", desc: "Cocktails sans alcool pour tous : idéal pour les événements familiaux, kermesses et fêtes de fin d'année." },
  { icon: ConciergeBell, title: "Service bénévole", desc: "Serveurs professionnels pour soutenir vos bénévoles lors de vos repas associatifs et événements caritatifs." },
  { icon: Tag, title: "Tarifs adaptés", desc: "Des prix spéciaux pour les associations et comités, parce qu'on croit en l'engagement collectif." },
];

const avantages = ["Tarifs préférentiels associations", "Devis gratuit sans engagement", "Flexibilité et adaptation", "Expérience événements associatifs", "Matériel fourni", "Accompagnement personnalisé"];
const types = ["Gala annuel", "Kermesse", "Fête de fin d'année", "Repas associatif", "Tournoi sportif", "Soirée caritative", "Assemblée générale", "Fête des voisins"];

export default function Associations() {
  return (
    <div className="fade-in" data-testid="associations-page">
      <section className="py-12 md:py-20 px-4 md:px-8 max-w-5xl mx-auto text-center">
        <h1 className="text-3xl sm:text-4xl font-light tracking-tight mb-4" style={{ fontFamily: 'Outfit' }}>OFFRE ASSOCIATIONS</h1>
        <p className="text-base text-[#A1A1AA] max-w-2xl mx-auto mb-8">{"RSX CONCEPT soutient les associations et comités dans l'organisation de leurs événements. Des tarifs adaptés et un accompagnement sur mesure pour faire vivre vos projets collectifs."}</p>
        <Link to="/reservation"><Button className="bg-[#D4AF37] text-black hover:bg-[#F9E5C0] rounded-full px-8 py-3 font-semibold" data-testid="association-devis">Demander un devis association</Button></Link>
      </section>
      <section className="py-12 px-4 md:px-8 max-w-6xl mx-auto">
        <h2 className="text-xl font-semibold text-center mb-10" style={{ fontFamily: 'Outfit' }}>NOS SERVICES POUR LES ASSOCIATIONS</h2>
        <div className="grid sm:grid-cols-2 gap-6">
          {services.map(s => (
            <div key={s.title} className="bg-[#121212] border border-white/5 rounded-2xl p-6 card-hover">
              <s.icon className="w-8 h-8 text-[#D4AF37] mb-4" />
              <h3 className="font-semibold mb-2" style={{ fontFamily: 'Outfit' }}>{s.title}</h3>
              <p className="text-sm text-[#A1A1AA] leading-relaxed">{s.desc}</p>
            </div>
          ))}
        </div>
      </section>
      <section className="py-12 px-4 md:px-8 max-w-5xl mx-auto">
        <h2 className="text-xl font-semibold text-center mb-8" style={{ fontFamily: 'Outfit' }}>POURQUOI RSX CONCEPT ?</h2>
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-3 mb-10">
          {avantages.map(a => (<div key={a} className="flex items-center gap-3 bg-[#121212] border border-white/5 rounded-xl p-4"><Check className="w-4 h-4 text-[#D4AF37] shrink-0" /><span className="text-sm">{a}</span></div>))}
        </div>
        <div>
          <h3 className="text-sm font-semibold text-[#D4AF37] mb-4" style={{ fontFamily: 'Outfit' }}>{"Types d'événements"}</h3>
          <div className="flex flex-wrap gap-2">{types.map(t => (<span key={t} className="bg-[#D4AF37]/10 text-[#D4AF37] text-xs px-3 py-1.5 rounded-full">{t}</span>))}</div>
        </div>
      </section>
      <section className="py-12 px-4 md:px-8">
        <div className="max-w-3xl mx-auto gold-bg gold-border rounded-2xl p-8 md:p-12 text-center">
          <Heart className="w-8 h-8 text-[#D4AF37] mx-auto mb-4" />
          <h2 className="text-2xl font-semibold mb-3" style={{ fontFamily: 'Outfit' }}>{"ENSEMBLE, CRÉONS DES MOMENTS INOUBLIABLES"}</h2>
          <p className="text-[#A1A1AA] mb-6">{"Contactez-nous pour discuter de votre projet associatif et bénéficier de nos tarifs préférentiels."}</p>
          <Link to="/reservation"><Button className="bg-[#D4AF37] text-black hover:bg-[#F9E5C0] rounded-full px-8 py-3 font-semibold">Demander un devis gratuit</Button></Link>
        </div>
      </section>
    </div>
  );
}
